import React from "react";
import Select from "../../../shared/CustomSelect";
import ValidatedInput from "../../../shared/ValidatedInput";

export default class FamilyBackgroundInfo extends React.PureComponent {
  render() {
    const {
      getProfileFieldLabel,
      isProfileFieldRequired,
      jewishBackgroundTypes,
      onChangeProfile,
      profile: { fatherBackground, motherBackground } = {},
      showFormValidation,
    } = this.props;

    return (
      <div className="student-profile-form-section">
        <p className="profile-section-title">Family background</p>
        <div className="student-profile-form-grid">
          <div className="relative">
            <ValidatedInput
              className="input-container"
              input={
                <Select
                  classNamePrefix="input-container-select"
                  options={jewishBackgroundTypes.map((bg) => ({
                    label: bg.displayValue,
                    value: bg.enumValue,
                  }))}
                />
              }
              label={getProfileFieldLabel(
                "Father's background",
                "fatherBackground",
              )}
              name="fatherBackground"
              onChange={onChangeProfile}
              required={isProfileFieldRequired("fatherBackground")}
              showRequired={showFormValidation}
              value={fatherBackground}
            />
          </div>
          <div className="relative">
            <ValidatedInput
              className="input-container"
              input={
                <Select
                  classNamePrefix="input-container-select"
                  options={jewishBackgroundTypes.map((bg) => ({
                    label: bg.displayValue,
                    value: bg.enumValue,
                  }))}
                />
              }
              label={getProfileFieldLabel(
                "Mother's background",
                "motherBackground",
              )}
              name="motherBackground"
              onChange={onChangeProfile}
              required={isProfileFieldRequired("motherBackground")}
              showRequired={showFormValidation}
              value={motherBackground}
            />
          </div>
        </div>
      </div>
    );
  }
}
